import {ICrudLocale} from "../../../i18n/interface";

export const PROFESSIONAL_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  PROFESSIONAL_MANAGEMENT: {
    LABEL: {
      SINGULAR: "Profesional",
      PLURAL: "Profesionales"
    },
    FIELD: {
      NAME: 'Nombre',
      USERNAME: 'Usuario',
      EMAIL: 'Email',
      GENDER: 'Género',
      ENABLED: 'Activo',
      LASTNAME: 'Apellido',
      PASSWORD: 'Contraseña',
      MOBILE: 'Teléfono',
      ROL: 'Rol',
      BIRTHDATE: 'Fecha de nacimiento',
      SELF_GENERATED_PASSWORD: 'Contraseña autogenerada',
      LAST_LOGIN: 'Último acceso',
      CENTER: 'Centro',
      DOC_TYPE: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'PASSPORT',
      },
      SPECIALTY: 'Especialidad',
      DEPARTMENT: 'Área/Departamento',
      ASSIGNED_PATIENTS: 'Pacientes asignados'
    },
    TEXT: {
      DELETE_MESSAGE: 'Si lo eliminas, todos los datos serán borrados.<br> <b>Esta acción no es reversible.</b>',
      ASSIGN_PATIENT: 'Asignar pacientes',
      LOADING_PATIENTS: 'Cargando pacientes...',
      NO_PATIENTS_TO_ASSIGN: ' Lo sentimos no hay pacientes disponibles para asignar.',
    },
    ERROR: {
      LOAD_FORM_RESOURCES: 'Lo sentimos ha ocurrido un error al cargar el formulario.',
      CHANGE_CENTER_MESSAGE: 'Esta cambiando de centro al professional y tiene algunos pacientes asignados. Si continua, estos pacientes quedarán disponibles para volver a asignarle un profesional nuevo.',
    },
    LIST: {
      TITLE: "Listado de profesionales",
      FILTERS: 'Filtros',
    }
  }
}
